import { render } from "./MyInQuriyView.vue?vue&type=template&id=6c52182f"
import script from "./MyInQuriyView.vue?vue&type=script&lang=js"
export * from "./MyInQuriyView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__